import {s as styles} from "../../common/index-fe254d98.js";
import "../../common/_commonjsHelpers-8c19dec8.js";
import "../../common/interopRequireDefault-d2c9da36.js";
import "../../common/defaultTheme-ca6a0b43.js";
import "../../common/capitalize-c580b26a.js";
import "../../common/index-877ea290.js";
import "../../common/hoist-non-react-statics.cjs-7c8198a1.js";
import "../../common/colorManipulator-ba921df7.js";
import "../../common/useForkRef-edb3fede.js";
import "react";
import "../../common/emotion-element-99289b21.browser.esm-15d91a3a.js";
import "../../common/useTheme-81ac7d8e.js";
import "../../common/useEventCallback-4c5b62b3.js";
import "../../common/clsx.m-5dc7436b.js";
import "react/jsx-runtime";
import "../../common/nested-5a43708e.js";
import "../../common/useTheme-ad5c2c5a.js";
import "../../common/useThemeProps-ef190a94.js";
var ThemeProvider = styles.ThemeProvider;
var createTheme = styles.createTheme;
var lighten = styles.lighten;
export {ThemeProvider, createTheme, lighten};
